/**
 * Preview-token mint for the Safari/iPad native-HLS path (BUG-161, ADR-024).
 *
 * Native HLS (`<audio src>`) cannot attach an `Authorization` header, so the
 * player bar first POSTs here (Bearer via `apiClient` as usual) and then
 * hands `<audio>` the manifest URL with `?token=<token>` appended. The token
 * is short-lived (5 min) and only unlocks this track's preview chain.
 *
 * Plain async function (not a TanStack hook): the call is imperative — one
 * fresh token per playback attach — and must never be cached or refetched in
 * the background.
 */

import type { TrackPreviewTokenResponse } from '@music-app/shared';
import { apiClient } from '../lib/api-client';

export function fetchTrackPreviewToken(
  trackId: string,
): Promise<TrackPreviewTokenResponse> {
  return apiClient<TrackPreviewTokenResponse>(
    `/admin/tracks/${trackId}/preview-token`,
    { method: 'POST' },
  );
}
